import styled from 'styled-components';
import { Input, TextAreaProps } from 'formik-antd';

export type PropsTextAreaProps = TextAreaProps & {};

export default styled(Input.TextArea)<PropsTextAreaProps>`
  border: 1px solid #e6e6e6;
  background-color: #ffffff;
  padding: 8px;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
`;
